import React from "react";
import styled from "@emotion/styled";

const SummaryContainer = styled.div`
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 5px;
    background-color: #f9f9f9;
    margin: 8px auto;
    width: 95%;
`;


export default SummaryContainer;
